import { createFileRoute } from '@tanstack/react-router'
import { EmailConfirmPage } from '../components/email-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/confirm')({
  head: () => noIndexRouteHead('emailConfirm', 'en'),
  component: EmailConfirmPage,
})
